/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-07 16:47:37
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-07-07 16:22:16
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/index.js
 * @Description: p1
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import PropTypes from 'prop-types'
import s from '../form.css';
import { groupDataset, parseArrayToTable, parseMapToArray, parseStringToArray } from '../utils';
import classnames from 'classnames';
import { drop, head } from 'lodash';
import { getVisual } from '../../../controller';

const defaultColorValue = `
小罐茶	#e46c0a	#fac090	#fdeada
竹叶青	#77933c	#95b94b	#cdff67
农夫山泉	#558ed5	#8eb4e3	#c5d8f0
`;

class Form extends React.Component {
  static propTypes = {
    onChange: PropTypes.func,
    children: PropTypes.node,
  }
  constructor(props) {
    super(props);

    this.state = {
      value: '',
      colorValue: defaultColorValue,
      dataset: [],
      chartTitle: [],
      chartList: [],
      chartColorList: [],
    }
  }

  componentDidMount () {
    this.loadData();
  }

  loadData = () => {
    const { onChange } = this.props;

    getVisual(8).then(value => {
      const _table = Form.parse(value);
      const _tempColor = Form.parseColor(defaultColorValue);

      this.setState({
        value: value,
        ..._table,
        ..._tempColor
      })
  
      typeof onChange === 'function' && onChange({
        ..._table,
        ..._tempColor
      });
    });
  }

  static parse = (str) => {
    const dataset = parseStringToArray(str);
    if (!dataset) return null;

    return {
      dataset,
      ...Form.parseChart(dataset),
    }
  }

  static parseChart = (arr) => {
    const xAxis = drop(head(arr), 3);
    const source = drop(arr, 1);
    const result = parseMapToArray(groupDataset(source, 3));

    return {
      chartTitle: xAxis,
      chartList: result,
    };
  }

  static parseColor = (str) => {
    const chartColorList = parseStringToArray(str);
    const { columns: tableColumns, list: tableList} = parseArrayToTable([
      ['', '正向词频', '中立词频', '负向词频'],
      ...chartColorList
    ], {});

    return {
      tableColumns,
      tableList,
      chartColorList: chartColorList.map(item => drop(item, 1))
    }
  }

  onChange = (e) => {
    const { onChange } = this.props;
    const value = e.target.value;
    const tableData = Form.parse(value, this.state.tableColorList);
    this.setState({ value, ...tableData });

    typeof onChange === 'function' && onChange(tableData)
  }

  onChangeColor = (e) => {
    const { onChange } = this.props;
    const value = e.target.value;
    const _color = Form.parseColor(value);

    this.setState({
      colorValue: value,
      ..._color,
    })

    typeof onChange === 'function' && onChange(_color)
  }

  render() {
    return (
      <div className={s.root}>
        <div>数据设置</div>
        <textarea className={classnames(s.inputText)} value={this.state.value} onChange={this.onChange} />
        <div>颜色设置（颜色只和顺序有关）</div>
        <textarea className={classnames(s.inputText)} value={this.state.colorValue} onChange={this.onChangeColor} />
      </div>
    );
  }
}

export default withStyles(s)(Form);



// WEBPACK FOOTER //
// src/routes/visualChart/P8/Form.js